export default __webpack_public_path__ + "img/rule41back-d8ab7e75.png";